// extracted by mini-css-extract-plugin
module.exports = {"root":"AdminPanel_root__a8yMR","slidein":"AdminPanel_slidein__woiym","layout":"AdminPanel_layout__5hRV6","closeBtn":"AdminPanel_closeBtn___e7ZV"};